import { render, staticRenderFns } from "./MyJobsTray.vue?vue&type=template&id=74b9e807&scoped=true"
import script from "./MyJobsTray.vue?vue&type=script&lang=js"
export * from "./MyJobsTray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b9e807",
  null
  
)

export default component.exports